// src/Api/DocumentsApi.js
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebaseConfig";

const API_BASE_URL = process.env.REACT_APP_API_URL;

const DocumentsApi = {
  /**
   * Lataa tiedoston Storageen ja rekisteröi metadatan backendissä.
   * Palauttaa tallennetun dokumentti-objektin (sis. id).
   */
  async uploadDocument(companyId, file, metadata = {}) {
    if (!companyId) throw new Error("missing_company_id");
    if (!file) throw new Error("missing_file");

    const safeName = `${Date.now()}_${file.name}`.replace(/\s+/g, "_");
    const storagePath = `companies/${companyId}/documents/${safeName}`;

    // 1) Upload Storageen
    const storageRef = ref(storage, storagePath);
    await uploadBytes(storageRef, file);
    const url = await getDownloadURL(storageRef);

    // 2) Rekisteröi metadata backendin kautta
    const res = await fetch(`${API_BASE_URL}/saveDocumentMetaData`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        companyId,
        name: file.name,
        sizeBytes: file.size,
        url,
        storagePath,
        contentType: file.type || null,
        ...metadata, // category, visibility, uploadedBy, uploadedByName 
      }),
    });

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      const e = new Error(err?.error || "register_document_failed");
      e.code = err?.error || "register_document_failed";
      throw e;
    }

    return await res.json(); // { id, companyId, name, ... }
  },

  async fetchDocuments(companyId, { etag } = {}) {
    if (!companyId) throw new Error("missing_company_id");

    const headers = {};
    if (etag) headers["If-None-Match"] = etag;

    const res = await fetch(
      `${API_BASE_URL}/fetchDocuments?companyId=${encodeURIComponent(companyId)}`,
      { headers }
    );

    if (res.status === 304) {
      return { status: 304 };
    }

    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      const e = new Error(err?.error || "fetch_documents_failed");
      e.code = err?.error || "fetch_documents_failed";
      throw e;
    }

    const body = await res.json();
    const newEtag = res.headers.get("ETag");

    /**
     * documents[] sisältää nyt:
     *  - perusmetadatan
     *  - ai: { summary, suggestedTags, docType, analyzedAt } | null
     */
    return {
      status: 200,
      documents: body.documents || [],
      etag: newEtag || null,
    };
  },
};

export default DocumentsApi;
